import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate from './Translate';
import Tooltip from './Tooltip';
import SortToggle from './SortToggle';
import { ColumnHeader } from './Grid';
import ColumnDropdown from './ColumnDropdown';
import isSortableColumn from '../utils/isSortableColumn';
import getSortKeyFromColumn from '../utils/getSortKeyFromColumn';
import getColumnLabel from '../utils/getColumnLabel';
import isExistingAdvancedSort from '../utils/isExistingAdvancedSort';
import get from 'lodash/get';
import { computed } from 'mobx';

const ColumnHeaderInner = styled<any, any>('div')`
    ${propStyles};
`;

ColumnHeaderInner.defaultProps = {
    display: 'flex',
    alignItems: 'center',
};

const ColumnLabel = styled<any, any>('div')`
    ${propStyles};
`;

ColumnLabel.defaultProps = {
    flex: '1 1 auto',
    textAlign: 'center',
};

@inject('dataStore')
@observer
class Column extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.handleSortClick = this.handleSortClick.bind(this);
    }

    @computed
    get direction() {
        const { dataStore, column } = this.props;

        if (
            dataStore.advancedSort &&
            isExistingAdvancedSort(column, dataStore.advancedSort)
        ) {
            return get(dataStore, 'advancedSort.direction', '');
        } else {
            const key = getSortKeyFromColumn(column);
            return get(
                dataStore.propertySort.find(c => c.key === key),
                'direction',
                ''
            );
        }
    }

    handleSortClick() {
        const { dataStore, column } = this.props;
        dataStore.toggleSort(column);
    }

    render() {
        const {
            theme,
            dataStore,
            column,
            selectedGroupIndex,
            setSelectedGroup,
            children,
            ...props
        } = this.props;

        const sortable = isSortableColumn(column);
        const columnLabel = getColumnLabel(column, dataStore);

        return (
            <ColumnHeader
                {...theme.ColumnHeader}
                {...props}
                width={column.width}
                verticalAlign={column.verticalAlign}
                textAlign={column.textAlign || 'center'}
            >
                <ColumnHeaderInner {...theme.ColumnHeaderInner}>
                    {column.type === 'dropdown' ? (
                        <ColumnDropdown
                            column={column}
                            selectedGroupIndex={selectedGroupIndex}
                            setSelectedGroup={setSelectedGroup}
                            dataStore={dataStore}
                        />
                    ) : (
                        column.showLabel !== false && (
                            <ColumnLabel
                                {...theme.ColumnLabel}
                                textAlign={column.textAlign || 'center'}
                            >
                                <Translate>{columnLabel}</Translate>
                                <Tooltip
                                    content={column.disclaimers}
                                    accessibilityContext={`for disclaimers of the ${columnLabel} column`}
                                />
                            </ColumnLabel>
                        )
                    )}
                    {sortable && (
                        <SortToggle
                            direction={this.direction}
                            onClick={this.handleSortClick}
                        />
                    )}
                </ColumnHeaderInner>
                {children}
            </ColumnHeader>
        );
    }
}

export default withTheme(Column) as any;



// WEBPACK FOOTER //
// ./src/Components/Column.tsx